module.exports = __webpack_public_path__ + "img/img4.d04da681.jpg";